import { useState } from 'react'

import Icon from '../../../../components/UI/Icon'

import {
  tradingMarketFavorites,
  tradingMarketTableHeadings,
  tradingMarketTableRows,
} from '../../../../constants'

const TradingMarketTable = () => {
  const [favorite, setFavorite] = useState(tradingMarketFavorites[0])
  const canLoadMore = true

  const handleLoadMore = () => {}

  const tradingMarketFavoritesContent = tradingMarketFavorites.map((tradingMarketFavorite) => {
    const isActive = favorite === tradingMarketFavorite

    return (
      <button
        key={tradingMarketFavorite}
        className={`py-[8px] px-[16px] text-sm font-normal ${isActive ? 'text-[#007bff]' : 'text-[#4a4a4a]'}`}
        onClick={() => setFavorite(tradingMarketFavorite)}
      >
        {tradingMarketFavorite}
      </button>
    )
  })

  const tradingMarketTableHeadingsContent = tradingMarketTableHeadings.map(
    (tradingMarketTableHeading) => {
      return (
        <th
          key={tradingMarketTableHeading}
          className="text-[#758696] font-normal p-[15px] text-sm w-[16%]"
        >
          {tradingMarketTableHeading}
        </th>
      )
    }
  )

  const tradingMarketTableRowsContent = tradingMarketTableRows.map((tradingMarketTableRow) => {
    return (
      <tr
        key={tradingMarketTableRow.id}
        className="border-t-[#f0f3fa] border-t-[1px] hover:bg-[#f6f8f9]"
      >
        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          <div className="flex items-center">
            <Icon name="star-solid" color="#75869696" className="w-[11px] h-[17px]" />

            <span>&nbsp;{tradingMarketTableRow.pairs}</span>
          </div>
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          <div className="flex items-center">
            <img
              src={tradingMarketTableRow.coinIcon}
              alt={tradingMarketTableRow.coin}
              className="w-[18px] h-[18px] mr-[5px]"
            />

            <span>&nbsp;{tradingMarketTableRow.coin}</span>
          </div>
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          {tradingMarketTableRow.lastPrice}
        </td>

        <td
          className={`text-sm p-[15px] w-[16%] font-normal ${tradingMarketTableRow.change.startsWith('+') ? 'text-green-trading' : 'text-red-trading'}`}
        >
          {tradingMarketTableRow.change}
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          {tradingMarketTableRow.high}
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          {tradingMarketTableRow.low}
        </td>

        <td className="text-sm p-[15px] w-[16%] text-[#4a4a4a] font-normal">
          {tradingMarketTableRow.volume}
        </td>
      </tr>
    )
  })

  return (
    <div className="w-full flex flex-col pb-[50px]">
      <div className="w-full flex items-center bg-[#f5f9fc] py-[7px] border-b-[#dee2e6] border-b-[1px]">
        <span className="text-[#4a4a4a] py-[8px] px-[16px] text-sm font-normal">★ Favorites</span>

        <div className="flex items-center">{tradingMarketFavoritesContent}</div>
      </div>

      <table className="bg-white w-full text-[#212529] border-collapse">
        <thead>
          <tr>{tradingMarketTableHeadingsContent}</tr>
        </thead>
        <tbody>{tradingMarketTableRowsContent}</tbody>
      </table>

      {canLoadMore && (
        <button
          className="flex items-center mx-auto mt-[50px] px-[30px] py-[11px] border-[1px] border-white rounded-[4px]"
          onClick={handleLoadMore}
        >
          <span className="text-base font-semibold text-white">Load More&nbsp;</span>

          <Icon name="arrow-down-solid" color="#fff" className="w-[10.69px] h-[20px] ml-[10px]" />
        </button>
      )}
    </div>
  )
}

export default TradingMarketTable
